import L from "leaflet";

import iconRetinaUrl from '../../node_modules/leaflet/dist/images/marker-icon-2x.png';
import iconUrl from "../../node_modules/leaflet/dist/images/marker-icon.png";
import shadowUrl from '../../node_modules/leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: themeajax.themeurl+'/dist/'+iconRetinaUrl,
  iconUrl: themeajax.themeurl+'/dist/'+iconUrl,
  shadowUrl: themeajax.themeurl+'/dist/'+shadowUrl
});

export class LeafletMap {

    constructor(elementId) {

        this.activeMarker = null;
        this.openMarker = null;

        this.map = L.map(elementId, {
            scrollWheelZoom: false,
            zoomControl: false,
            maxZoom:20,
            minZoom:5,
            tap: L.Browser.safari && L.Browser.mobile
        });

        this.bounds = L.latLngBounds();
        this.markers = [];

        const layer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:'',
            className: 'bw'
        });

        // const layer = L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.{ext}', {
        //     attribution: '',
        //     subdomains: 'abcd',
        //     minZoom: 0,
        //     maxZoom: 20,
        //     ext: 'png'
        // });

        // const layer = L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
        //     maxZoom: 20,
        //     attribution: ''
        // });

        // const layer = L.tileLayer('https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png', {
        //     maxZoom: 20,
        //     attribution: ''
        // });

        // const layer = L.tileLayer('https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=lqlkWjMqIxfnKYwxIseK', {
        //     maxZoom: 20,
        //     attribution: '',
        //     className: 'bw'
        // });

        layer.addTo(this.map);

        const control = L.control.zoom({
            zoomInTitle: 'Avancer',
            zoomOutTitle: 'Reculer',
            zoomInText: '<span class="map-zoom map-zoom-plus">+</span>',
            zoomOutText: '<span class="map-zoom map-zoom-minus">-</span>',
            position: 'topleft'
        });

        control.addTo(this.map);

        this.map.setView([46.7,2.0], 6);


        this.map.on('popupopen', function(){
            document.querySelectorAll('div.leaflet-control-container')[0].classList.add('transparent');
        });

        this.map.on('popupclose', function(){
            document.querySelectorAll('div.leaflet-control-container')[0].classList.remove('transparent');
        });
    }

    setCenter(point, zoom) {
        if(!zoom) zoom = 11;
        //console.log('zoom', zoom);
        this.map.setView(point, zoom);

        // On dézomme la carte jusqu'à voir un point
        // En gardant le centre à l'emplacement précédent

        setTimeout(() => {

            var bounds = this.map.getBounds();
            var count = 0;
    
            this.map.eachLayer(function(layer) {
                if (layer instanceof L.Marker) {
                    if (bounds.contains(layer.getLatLng())){
                        //console.log(bounds, layer.getLatLng());
                        count++;
                    }
                }
            });

            //var rect = L.rectangle(bounds, {color: 'blue', weight: 1}).addTo(this.map);

            //console.log('count', count);
            if( count==0 && zoom>this.map.getMinZoom() ){
            
                const newZoom = zoom - 1;
                //console.log('newZoom', newZoom);
                this.setCenter(point, newZoom);
                
            }

        }, 200);

        
    }

    autoCenter() {
        if( this.bounds.isValid() ){
            this.map.fitBounds(this.bounds, {
                padding: [20,20]
            });
        }
    }

    setBounds(latMin, latMax, lonMin, lonMax) {
        var bounds = L.latLngBounds(
            L.latLng(latMin, lonMin),
            L.latLng(latMax, lonMax)
        );

        console.log(bounds);

        this.map.fitBounds(bounds, {
            padding: [20,20]
        });
    }

    addMarker(point, $html, color) {

        this.bounds.extend(point);

        var marker = new LeafletMapMarker(point, $html, color, this);

        this.markers.push(marker);

        return marker;
    }

    removeMarkers() {
        //console.log(this.markers);

        for(let i=0 ; i<this.markers.length ; i++) {
            this.markers[i].remove();
        }

        this.bounds = L.latLngBounds();

    }

    resize() {
        this.map.invalidateSize();
    }

    unzoomUntilViewMarker() {
        
    }

    setActiveMarker(markerInstance){

        if(this.activeMarker){
            this.activeMarker.setActive(false);
        }
    
        if(this.openMarker && this.openMarker!=markerInstance){
            this.openMarker.setOpen(false);
        }
    
        markerInstance.setActive(true);
    
        this.activeMarker = markerInstance;
    }
    
    setOpenMarker(markerInstance){
        
        if(this.openMarker){
            this.openMarker.setOpen(false);
        }
    
        markerInstance.setOpen(true);
    
        this.openMarker = markerInstance;
    }


}

//import responsivePopup from 'leaflet-responsive-popup'

class LeafletMapMarker {

    constructor(point, $html, color, mapInstance) {

        this.mapInstance = mapInstance;
        this.map = this.mapInstance.map;

        this.icon = L.divIcon({ 
            className: 'map-marker color-'+color,
            popupAnchor: [0,20],
            iconSize: [40,40]
        });

        this.marker = L.marker(point, {
            icon: this.icon,
        });

        this.marker.on('add', function() { // called when the specific marker is added to the map
            //console.log('marker added');
        }); 

        this.marker.addTo(this.map);
    
        this.popup = L.popup({
            className: 'map-popup',
            maxWidth: 240,
            offset: [0, -30],
            autoPanPadding: [20,20],
            keepInView: true,
            closeButton: false,
            autoPan: true
        }).setLatLng(point).setContent($html);

        this.marker.bindPopup(this.popup);

        // this.marker.getElement().addEventListener('click', () => {
        //     this.mapInstance.setOpenMarker(this);
        // });

    }

    remove() {
        this.marker.removeFrom(this.map);
        this.popup.removeFrom(this.map);
    }

    setActive(bool) {
        const $elem = this.marker.getElement();
        if($elem){
            if(bool){
                $elem.classList.add('map-marker-active');
            }else{
                $elem.classList.remove('map-marker-active');
            }
        }
        
    }

    setOpen(bool) {
        const $elem = this.marker.getElement();
        if($elem){
            if(bool){
                $elem.classList.add('map-marker-open');
            }else{
                $elem.classList.remove('map-marker-open');
            }
        }
        
    }

}
